import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import axios from 'axios'
import { AuthService } from '../../services/AuthService'

const server = process.env.REACT_APP_SERVER_URL
let authInstance = new AuthService()

const UserForm: React.FC<IUserForm> = ({ onClose, onSubmit }) => {
  const form = useForm()

  const { addAlert } = useSnackBars()

  let userTypes = [
    {
      value: 'cashier',
      text: 'Cajero',
      tooltipValue: "Tiene acceso solo al módulo de “Ventas”. No puede generar ventas a crédito."
    },
    {
      value: 'admin',
      text: 'Admin. Sistema',
      tooltipValue: "Tiene acceso a todos los módulos a excepción de Estadísticas del Negocio y Configuración."
    },
    {
      value: 'general_manager',
      text: 'Gerente general',
      tooltipValue: "Tiene acceso a todos los módulos a excepción de Configuración."
    },
    {
      value: "waiter",
      text: "Mesonero",
      tooltipValue: "Puede crear y editar comandas"
    }
  ]

  const [alreadyExists, setAlreadyExists] = useState<boolean>(false)

  const onSubmitForm = (values) => {

    if (values?.realName?.trim() !== values?.realName) {
      form?.setError('realName', {
        type: 'manual',
        message: 'El nombre no debe tener espacios',
      })
      return
    }

    if(values?.password?.trim() !== values?.password) {
      form?.setError('password', {
        type: 'manual',
        message: 'La contraseña no debe tener espacios',
      })
      return
    }

    if (values.email.trim() !== values.email) {
      form?.setError('email', {
        type: 'manual',
        message: 'El correo no debe tener espacios',
      })
      return
    }
    if (alreadyExists) {
      addAlert({
        message: 'Correo ya existente',
        status: 'error',
      })
      return
    }

    if (values.password !== values.password2) {
      addAlert({
        message: 'Las contraseñas no coinciden',
        status: 'error',
      })
      return
    }
    onSubmit(values)
  }

  return (
    <Form form={form} onSubmit={onSubmitForm}>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Usuario
      </h2>

      <FormItem
        name="realName"
        classes="col-span-12"
        rules={{ required: 'Es necesario el nombre' }}
      >
        <InputText small label="Nombres" />
      </FormItem>

      <FormItem
        name="userRole"
        defaultValue={userTypes[0]}
        classes="col-span-12"
      >
        <Select
          options={userTypes}
          setSelectedHelper={async (v) => {}}
          label="Tipo"
        />
      </FormItem>

      <FormItem
        name="email"
        classes="col-span-12"
        rules={{ required: 'Es necesario el correo',
          pattern: {
            value: /^\S*$/,
            message: 'El correo no debe contener espacios'
          }

// validate: (value) => {
//             console.log('value probando...', value)
//             if (value.trim() !== value) {
//               console.log('value...', value)
//               return 'El correo no debe contener espacios al inicio o al final'
//             }
//             return true
//           }

         }}
        
      >
        <InputText
          small
          label="Correo"
          onCheckIfExist={async () => {
            let email = form.getValues().email
            // let response = await axios.get(
            //   `${server}/user/tenant/check?email=${email}`
            // )
            let ifExist = await authInstance.userExists(form.getValues().email?.toLowerCase())

            if (ifExist) {
              form?.setError('email', {
                type: 'manual',
                message: 'Email ya existente',
              })
              setAlreadyExists(true)
            } else {
              setAlreadyExists(false)
              form?.clearErrors('email')
            }
          }}
        />
      </FormItem>

      <FormItem
        name="password"
        classes="col-span-12"
        rules={{ 
          required: 'Es necesario la contraseña',
          pattern: {
            value: /^[a-zA-Z0-9@#$%!^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/,
            message: 'Caracteres no válidos'
          }
        }}
      >
        <InputText small label="Contraseña" password />
      </FormItem>

      <FormItem
        name="password2"
        classes="col-span-12"
        rules={{ required: 'Es necesario la contraseña' }}
      >
        <InputText small label="Confirmar contraseña" password />
      </FormItem>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      <div className="col-start-4 col-span-9 flex space-x-2 px-1 mt-4 row-start-8 block lg:col-start-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Añadir
        </Button>
      </div>
    </Form>
  )
}

interface IUserForm {
  onClose: () => void
  onSubmit: (values: any) => void
}

export default UserForm
